import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/seo"
import Content from "../components/Common/Content"
import Wrapper from "../components/Common/Wrapper"
import { Title, TextSm, TitleSm, TextPCentered } from "../components/Text"
import Splitter, { SmSplitter } from "../components/Splitter"
import Gallery from "../components/Gallery"

import text from "../data/text.json"

const cafetxt = text.cafe

const CafePage = ({ data }) => (
  <Layout>
    <SEO title="Cafe" />
    <Wrapper>
      <Content>
        <Title>{cafetxt.title}</Title>
        <TextPCentered>
          <TextSm>{cafetxt.intro}</TextSm>
          <SmSplitter />
          <TitleSm>{cafetxt.menuTitle}</TitleSm>
          <TextSm>{cafetxt.menu}</TextSm>
          <SmSplitter />
          <TextSm>{cafetxt.extra}</TextSm>
          <Splitter />
        </TextPCentered>
        <Gallery queryData={data.allFile.edges} />
      </Content>
    </Wrapper>
  </Layout>
)

export const query = graphql`
  {
    allFile(filter: { relativeDirectory: { eq: "cafe" } }) {
      edges {
        node {
          childImageSharp {
            id
            fluid(maxWidth: 1000, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

export default CafePage
